// Apply both discounts when .proeve-koeb is clicked, then trigger original buy
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.proeve-koeb').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var rawDiscount = 'Prøvepakke-rabat';
            var encodedDiscount = encodeURIComponent(rawDiscount);
            var secondDiscount = 'Prøvepakke-gratis-fragt';
            var encodedSecondDiscount = encodeURIComponent(secondDiscount);

            // Apply first discount
            fetch(`/discount/${encodedDiscount}`)
                .then(function () {
                    // Apply second discount
                    return fetch(`/discount/${encodedSecondDiscount}`);
                })
                .then(function () {
                    // After both discounts, trigger the original buy/add-to-cart action
                    // If .proeve-koeb is a button inside a form, submit the form
                    var form = btn.closest('form');
                    if (form) {
                        form.submit();
                    } else {
                        // Or trigger a click on the real buy/add-to-cart button if needed
                        var realBuyBtn = document.querySelector('.real-buy-btn');
                        if (realBuyBtn) realBuyBtn.click();
                    }
                })
                .catch(function (error) {
                    console.error('[Discount Debug] Error applying discounts:', error);
                });
        });
    });
});
document.addEventListener("DOMContentLoaded", function() {
    // Set discount_code cookie on page load
    // Helper to get cookie value
/*     function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Helper to set cookie
    function setCookie(name, value, options = {}) {
        let cookieStr = `${name}=${encodeURIComponent(value)}`;
        if (options.path) cookieStr += `; path=${options.path}`;
        if (options.expires) cookieStr += `; expires=${options.expires}`;
        if (options.sameSite) cookieStr += `; SameSite=${options.sameSite}`;
        document.cookie = cookieStr;
    }

    // Only run discount logic if not already handled
    var discountCode = getCookie('discount_code');
    var discountHandled = getCookie('discount_handled');
    var rawDiscount = 'Prøvepakke-rabat';
    var encodedDiscount = encodeURIComponent(rawDiscount);
    var secondDiscount = 'Prøvepakke-gratis-fragt';
    var encodedSecondDiscount = encodeURIComponent(secondDiscount);
    var secondDiscountHandled = getCookie('second_discount_handled');

    if (!discountCode) {
        setCookie('discount_code', rawDiscount, { path: '/', sameSite: 'Lax' });
        discountCode = encodedDiscount;
    }

    if (encodeURIComponent(discountCode) === encodedDiscount && !discountHandled) {
        // Send GET request to "/discount/[encodedDiscount]"
        fetch(`/discount/${encodedDiscount}`)
        .then(function() {
            // After the discount code has been applied, force the cart to update so the discount is visible instantly
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: {},
                }),
            });
        })
        .then(function() {
            // Mark discount as handled so it doesn't run again
            setCookie('discount_handled', '1', { path: '/', sameSite: 'Lax' });
            // Now run the second discount if not already handled
            if (!secondDiscountHandled) {
                fetch(`/discount/${encodedSecondDiscount}`)
                .then(function() {
                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: {},
                        }),
                    });
                })
                .then(function() {
                    setCookie('second_discount_handled', '1', { path: '/', sameSite: 'Lax' });
                })
                .catch(function(error) {
                    console.error('Error during second discount logic:', error);
                });
            }
        })
        .catch(function(error) {
            console.error('Error during discount logic:', error);
        });
    } */

// UPDATED DISCOUNTING LOGIC
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Helper to set cookie
function setCookie(name, value, options = {}) {
    let cookieStr = `${name}=${encodeURIComponent(value)}`;
    if (options.path) cookieStr += `; path=${options.path}`;
    if (options.expires) cookieStr += `; expires=${options.expires}`;
    if (options.sameSite) cookieStr += `; SameSite=${options.sameSite}`;
    document.cookie = cookieStr;
}

// Only run on /proevepakke page
if (window.location.pathname.includes('/proevepakke')) {
    var discountCode = getCookie('discount_code');
    var discountHandled = getCookie('discount_handled');
    var rawDiscount = 'Prøvepakke-rabat';
    var encodedDiscount = encodeURIComponent(rawDiscount);
    var secondDiscount = 'Prøvepakke-gratis-fragt';
    var encodedSecondDiscount = encodeURIComponent(secondDiscount);
    var secondDiscountHandled = getCookie('second_discount_handled');

    console.log('[Discount Debug] Initial cookie values:', {
        discountCode,
        discountHandled,
        secondDiscountHandled
    });


    if (!discountCode) {
        setCookie('discount_code', rawDiscount, { path: '/', sameSite: 'Lax' });
        // Re-read the cookie value after setting
        discountCode = getCookie('discount_code');
        console.log('[Discount Debug] Set discount_code cookie:', rawDiscount, 'Cookie now:', discountCode);
    }

    if (discountCode === encodedDiscount && !discountHandled) {
        console.log('[Discount Debug] Applying first discount:', encodedDiscount);
        fetch(`/discount/${encodedDiscount}`)
            .then(function () {
                console.log('[Discount Debug] First discount applied, updating cart');
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: {} })
                });
            })
            .then(function () {
                setCookie('discount_handled', '1', { path: '/', sameSite: 'Lax' });
                console.log('[Discount Debug] Set discount_handled cookie');
                if (!secondDiscountHandled) {
                    console.log('[Discount Debug] Applying second discount:', encodedSecondDiscount);
                    fetch(`/discount/${encodedSecondDiscount}`)
                        .then(function () {
                            console.log('[Discount Debug] Second discount applied, updating cart');
                            return fetch('/cart/update.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ updates: {} })
                            });
                        })
                        .then(function () {
                            setCookie('second_discount_handled', '1', { path: '/', sameSite: 'Lax' });
                            console.log('[Discount Debug] Set second_discount_handled cookie');
                        })
                        .catch(function (error) {
                            console.error('[Discount Debug] Error during second discount logic:', error);
                        });
                }
            })
            .catch(function (error) {
                console.error('[Discount Debug] Error during discount logic:', error);
            });
    }
}




    let columnFooter = document.querySelector('.shopify-section-group-footer-group .multicolumn');
    if (columnFooter) {
        const carousel = columnFooter.querySelector('ul');
        carousel.classList.add('swiper-wrapper'); // Add Swiper wrapper class

        // Remove grid-related classes while keeping the swiper-wrapper class
        const gridClasses = Array.from(carousel.classList).filter(cls => cls.startsWith('grid--'));
        gridClasses.forEach(cls => carousel.classList.remove(cls));

        const items = carousel.querySelectorAll('li');
        items.forEach(item => item.classList.add('swiper-slide')); // Add Swiper slide class to each item

        // Create Swiper container and navigation elements
        const swiperContainer = document.createElement('div');
        swiperContainer.className = 'swiper-container';
        swiperContainer.style.position = 'relative'; // Set position to relative
        swiperContainer.style.overflow = 'hidden'; // Prevent overflow
        carousel.parentNode.insertBefore(swiperContainer, carousel);
        swiperContainer.appendChild(carousel);

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        swiperContainer.appendChild(pagination);

        // Append navigation buttons to the container
        const nextButton = document.createElement('div');
        nextButton.className = 'swiper-button-next';
        swiperContainer.appendChild(nextButton);

        const prevButton = document.createElement('div');
        prevButton.className = 'swiper-button-prev';
        swiperContainer.appendChild(prevButton);

        // Ensure proper Swiper styling
        swiperContainer.style.width = '100%';
        carousel.style.display = 'flex'; // Ensure horizontal layout
        carousel.style.flexWrap = 'nowrap'; // Prevent wrapping of slides

        // Initialize Swiper with autoplay
        function initSwipers() {
            document.querySelectorAll('.swiper-container').forEach((swiperContainer) => {
                new Swiper(swiperContainer, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    breakpoints: {
                        970: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                    },
                    loop: true,
                    autoplay: {
                        delay: 6000, // Auto-slide every 3 seconds
                        disableOnInteraction: false, // Continue autoplay after user interaction
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });

                swiperContainer.classList.add('loaded');
                swiperContainer.parentElement.classList.add('swiper-loaded');
            });
        }

        // Call the function to initialize Swipers
        initSwipers();
    }
document.querySelectorAll('.bsub-widget__group input').forEach(input => {
  input.addEventListener('change', () => {
    const hasCustom = document.querySelector('.custom-price');
    if (input.value === 'once' && input.checked) {
      hasCustom.classList.remove('subscription-active');
    } else if (input.checked) {
      hasCustom.classList.add('subscription-active');
    }
  });

});

function updateSlsCustomState(container) {
  const hasCustom = document.querySelector('.has-custom');
  const customPrice = document.querySelector('.custom-price');
  if (!hasCustom) return;

  if (container.classList.contains('sls-active')) {
    const sealMoney = container.querySelector('.sls-price .seal-money');
    if (sealMoney) {
      const sealValue = parseFloat(sealMoney.textContent.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
      const customValue = parseFloat(hasCustom.textContent.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
      const priceValue = parseFloat(customPrice.textContent.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.')) || 0;

      if (sealValue === customValue) {
        hasCustom.classList.add('one-time-active');
        customPrice.classList.remove('subscription-active');
      } else if (sealValue === priceValue && customPrice) {
        customPrice.classList.add('subscription-active');
        hasCustom.classList.remove('one-time-active');
      } else {
        hasCustom.classList.remove('one-time-active');
        customPrice.classList.remove('subscription-active');
      }
    } else {
      hasCustom.classList.remove('one-time-active');
      customPrice.classList.remove('subscription-active');
    }
  }
}

setTimeout(() => {
  document.querySelectorAll('.sls-option-container').forEach(container => {
    // Run on load
    updateSlsCustomState(container);

    // Run on mutation
    const observer = new MutationObserver(() => {
      updateSlsCustomState(container);
    });
    observer.observe(container, { attributes: true, attributeFilter: ['class'] });
  });
}, 500);


// Replace text for recurring product discount
document.querySelectorAll('.bsub-widget__recurring-product-discounted-text').forEach(el => {
  const desiredText = "Spar 15% efter den første ordre";
  el.textContent = desiredText;

  const observer = new MutationObserver(() => {
    if (el.textContent !== desiredText) {
      el.textContent = desiredText;
    }
  });

  observer.observe(el, { childList: true, subtree: true, characterData: true });
});

// Replace kr with kr. only if not already kr.
function updateCartText() {
  document.querySelectorAll(
    '.cart-item__price-final, .bsub-widget__recurring-product-discounted-price, .cart-item__price-per-item-money, .bsub-widget__recurring-product-full-price, dd'
  ).forEach(el => {
    el.textContent = el.textContent.replace(/\bkr(?!\.)\b/g, 'kr.');
  });

  document.querySelectorAll('.cart-item__discount').forEach(el => {
    el.textContent = el.textContent.replace(
      /Prøvepakke-rabat/g,
      'Prøvepakke rabat -31 kr. + fri fragt'
    );
  });
}

setTimeout(updateCartText, 1000);

// Use event delegation for dynamically added elements
document.addEventListener('click', function (e) {
  if (
    e.target.closest('.featured-product__add-to-cart-button') ||
    e.target.closest('.quantity-selector__button') ||
    e.target.closest('.quantity-selector__input')
  ) {
    console.log('clicked');
    setTimeout(updateCartText, 1200);
  }
});





// Shipping CALC
const freeShippingCost = 300; 
const excludedProductPath = "/products/proevepakke"; 

const isExcludedProductInCart = () => {
    const cartItems = document.querySelectorAll(".cart-item__title");
    return Array.from(cartItems).some(item => item.getAttribute("href") === excludedProductPath);
};

const calculateFreeShippingMessage = () => { 
    const totalPriceEl = document.querySelector(".cart-footer__total-price");
    const cartFooterContainer = document.querySelector("#cart-footer-contents");
    const vatAndShippingText = document.querySelector("p.copy--xsmall.copy--italic.space--mt--medium.align--text-center");

    if (!totalPriceEl || !cartFooterContainer) return;

    const excludedInCart = isExcludedProductInCart();
    let cartShippingMessageContainer = document.querySelector(".free-shipping-message");
    let cartShippingMessage = "";

    const totalPriceString = totalPriceEl.textContent ?? "0";
    // Remove thousands separators (.) and replace decimal comma with dot
    const totalPriceNumber = parseFloat(
    totalPriceString.replace(/[^\d.,]/g, "") // keep only digits, . and ,
        .replace(/\./g, "")                   // remove all periods (thousands sep)
        .replace(",", ".")                    // replace decimal comma with dot
    ) || 0;
    const cartValueNeededForFreeShipping = freeShippingCost - totalPriceNumber;

    const freeShippingAchieved = excludedInCart || cartValueNeededForFreeShipping <= 0;

    if (freeShippingAchieved) {
        cartShippingMessage = "Wuhuu! - Du har opnået gratis levering";
        if (vatAndShippingText) vatAndShippingText.style.display = "none"; // Hide the element when free shipping achieved
    } else {
        cartShippingMessage = `Køb for ${cartValueNeededForFreeShipping.toFixed(2)} DKK mere, og få gratis levering`;
        if (vatAndShippingText) vatAndShippingText.style.display = ""; // Show it back when free shipping is not achieved
    }

    if (!cartShippingMessageContainer) {
        cartShippingMessageContainer = document.createElement("div");
        cartShippingMessageContainer.classList.add("free-shipping-message");
        cartFooterContainer.appendChild(cartShippingMessageContainer);
    }
    cartShippingMessageContainer.textContent = cartShippingMessage;
};

calculateFreeShippingMessage();

// Intercept fetch calls
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    if (arguments[0].toString().includes('/cart')) {
      const retryUpdate = (retries = 5) => {
        if (document.querySelector(".cart-footer__total-price")) {
          document.dispatchEvent(new CustomEvent('my-cart-updated'));
        } else if (retries > 0) {
          setTimeout(() => retryUpdate(retries - 1), 100);
        }
      };
      retryUpdate();
    }
    return response;
  };
})();

// Update after cart changes
document.addEventListener('my-cart-updated', calculateFreeShippingMessage);

// Remove Prøvepakke-gratis-fragt discount if Prøvepakken is not in cart
document.addEventListener('my-cart-updated', function() {
    // Check if Prøvepakken is in the cart
    const cartItems = document.querySelectorAll('.cart-item__title');
    const cartTitles = Array.from(cartItems).map(item => (item.textContent || '').trim().toLowerCase());
    const provepakkenInCart = cartTitles.some(title => title.includes('prøvepakken'));
    const flagKey = 'provepakken_was_in_cart';

    // If Prøvepakken is in cart, set the flag
    if (provepakkenInCart) {
        if (!localStorage.getItem(flagKey)) {
            localStorage.setItem(flagKey, '1');
            console.log('[Debug] Prøvepakken detected in cart, flag set');
        }
        return;
    }

    // If Prøvepakken is NOT in cart, but flag is set, remove discount and reset flag
    if (!provepakkenInCart && localStorage.getItem(flagKey)) {
        localStorage.removeItem(flagKey);
        console.log('[Debug] Prøvepakken removed from cart, attempting to clear discount with fetch("/discount/CLEAR") and resetting flag');
        fetch('/checkout?discount=CLEAR').then(() => {
            // Optionally, you can refresh the cart or page here if needed
            location.reload();
        });
        return;
    }
    // Otherwise, do nothing
    console.log('[Debug] No action needed for Prøvepakken logic');
});



// Subscription collective price
const container = document.querySelector('.featured-product__buy-buttons-actions');
const optionContainers = document.querySelectorAll('.bsub-option-container');
const overlayDiv = document.querySelector('.page-layout__overlay');
const groupLabels = document.querySelectorAll('.bsub-widget__group-label'); 

if (container && optionContainers.length > 0) {
    const plusButtons = container.querySelectorAll('.js-quantity-selector-button-plus');
    const minusButtons = container.querySelectorAll('.js-quantity-selector-button-minus');
    const quantityInput = container.querySelector('.quantity-selector__input');
    const UNIT_PRICE = 34;

    function updatePriceDisplay() {
        if (!quantityInput) return;
        const quantity = parseInt(quantityInput.value) || 1;
        const totalPrice = quantity * UNIT_PRICE;

        optionContainers.forEach(option => {
            const priceSpan = option.querySelector('.bsub-widget__plan-pricing span[data-bsub-per-delivery-price]');
            if (priceSpan) {
                priceSpan.textContent = `${totalPrice},00 kr.`;
            }
        });
    }

    plusButtons.forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();
            if (!quantityInput) return;
            quantityInput.value = (parseInt(quantityInput.value) || 1);
            updatePriceDisplay();
        });
    });

    minusButtons.forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();
            if (!quantityInput) return;
            let newValue = (parseInt(quantityInput.value) || 1);
            if (newValue < 1) newValue = 1;
            quantityInput.value = newValue;
            updatePriceDisplay();
        });
    });

    // Update on plan change as well
    optionContainers.forEach(option => {
        const input = option.querySelector('input[type="radio"]');
        if (input) {
            input.addEventListener('change', () => updatePriceDisplay());
        }
    });
    
    groupLabels.forEach(label => {
        label.addEventListener('click', () => {
            setTimeout(updatePriceDisplay, 300);
        });
    });

    if (overlayDiv) {
        overlayDiv.addEventListener('click', () => {
            setTimeout(updatePriceDisplay, 300);
        });
    }

    updatePriceDisplay();

    // Run again on page load after 1.5s
    window.addEventListener('load', () => {
        setTimeout(updatePriceDisplay, 500);
    });
}

});

